import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";
import "./incomeTeamCountries.css";

import denmarkFlag from "../../../assets/Countries/denmark.png";
import finlandFlag from "../../../assets/Countries/finland.png";
import swedenFlag from "../../../assets/Countries/sweden.png";
import norwayFlag from "../../../assets/Countries/norway.png";

export default function IncomeTeamCountries({ user }) {
  const navigate = useNavigate();

  const countries = [
    {
      name: "Denmark",
      route: "/income-team/denmark",
      flag: denmarkFlag
    },
    {
      name: "Finland",
      route: "/income-team/finland",
      flag: finlandFlag
    },
    {
      name: "Sweden",
      route: "/income-team/sweden",
      flag: swedenFlag
    },
    {
      name: "Norway",
      route: "/income-team/norway",
      flag: norwayFlag
    }
  ];

  return (
    <div className="income-countries-container">
      <Header user={user} />

      <div className="income-countries-grid">
        {countries.map((country, index) => (
          <div
            key={index}
            className="income-country-card"
            onClick={() => navigate(country.route)}
          >
            {/* ✅ FLAG */}
            <img
              src={country.flag}
              alt={`${country.name} flag`}
              className="income-country-flag"
            />

            {/* ✅ COUNTRY NAME */}
            <span className="income-country-name">
              {country.name}
            </span>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
}
